module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin": "0"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230721/user-0/20230721/1458dd179cf6e30a4f9e1b216e80ab6a.jpg?x-oss-process=style/tb-750"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d20bd5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/update.vue
// module id = 2535
// module chunks = 0